import axios from '@/libs/api.request'

export const getSecurityOverview = (params) => {
  return axios.request({
    url: '/v1/system/security-overview/',
    method: 'get',
    params
  })
}